import { Component, inject } from '@angular/core';

import { ButtonModule, IconModule, WINDOW } from '@hglobal/common';
import { TranslateModule } from '@ngx-translate/core';

@Component({
  selector: 'pp-lost-connection',
  imports: [ButtonModule, IconModule, TranslateModule],
  templateUrl: './lost-connection.component.html',
  styleUrl: './lost-connection.component.scss',
})
export class LostConnectionComponent {
  readonly #window = inject(WINDOW);

  refresh(): void {
    this.#window.location.reload();
  }
}
